import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select } from 'redux-saga/effects';
import { userProfile, planById } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { memberStatus } from 'enums/memberStatus';
import Base64Deriver from 'derivers/Base64';

export function* planChangeOnEnterSaga(client, nextState, replaceState) {
  const planId = Base64Deriver.decodeNumber(nextState.params.encodedId);
  const plan = yield call(fetchEntityIfNeeded, planById, [client, planId]);

  if (!plan.enabled) {
    yield call(replaceState, '/');
  } else if (!(yield select(isLoggedIn))) {
    yield call(replaceState, loginRedirectUrl(nextState.location));
  } else {
    const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);

    if (memberStatus('UNSUBSCRIBED', profile && profile.membership && profile.membership.status)) {
      return yield call(replaceState, '/');
    }
  }
}
